import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { LocationPageHero } from '../../components/locations/LocationPageHero';
import { LocationHighlights } from '../../components/locations/LocationHighlights';
import { LocationGallery } from '../../components/locations/LocationGallery';
import { CaroProgramsPricing } from '../../components/locations/CaroProgramsPricing';
import { LocationSchedule } from '../../components/locations/LocationSchedule';
import { LocationContactForm } from '../../components/locations/LocationContactForm';
import { getLocationById } from '../../data/locations';
export function CaroPage() {
  const location = getLocationById('caro');
  if (!location) {
    return <div data-id="element-940">Location not found</div>;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-941">
      <Header data-id="element-942" />

      <main data-id="element-943">
        <LocationPageHero location={location} data-id="element-944" />
        <LocationHighlights highlights={location.highlights} locationName={location.name} data-id="element-945" />
        {location.galleryImages && location.galleryImages.length > 0 && <LocationGallery images={location.galleryImages} locationName={location.name} data-id="element-946" />}
        <CaroProgramsPricing data-id="element-947" />
        <LocationSchedule schedule={location.schedule} hasSchedule={location.hasSchedule} locationName={location.name} data-id="element-948" />
        <LocationContactForm preselectedLocationId={location.id} data-id="element-949" />
      </main>

      <Footer data-id="element-950" />
    </div>;
}